import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GridModule } from '@progress/kendo-angular-grid';

import { AccessLocationsComponent } from './access-locations.component';
import { EditAccessLocationComponent } from '../../actionpanel/edit-access-location/edit-access-location.component';
import { SharedModule } from '@app/shared/shared.module';
import { AccessLocationService } from '@services/access-location.service';

@NgModule({
  declarations: [
    AccessLocationsComponent,
    EditAccessLocationComponent
  ],
  imports: [
    SharedModule,
    GridModule,
    RouterModule
  ],
  exports: [
    AccessLocationsComponent,
    EditAccessLocationComponent
  ],
  providers: [AccessLocationService]
})
export class AccessLocationModule { }
